import React, { FC } from "react"
import { Box, Group, Progress, Text } from "@mantine/core"

type BatteryStatusProps = {
    value: number
    charging?: boolean
    intervals?: [number, number, number]
}

const BatteryStatus: FC<BatteryStatusProps> = ({ value, charging = false, intervals = [20, 50, 100] }) => {
    const color = value <= intervals[0] ? "red" : value <= intervals[1] ? "orange" : value <= intervals[2] ? "green" : "gray"

    return (
        <Group spacing="xs" position="apart" style={{"maxWidth": "100px"}}>
            <Box sx={{ flexGrow: 1 }}>
                <Progress color={color} value={value} max={100} animate={charging} />
            </Box>
            <Text size="xs" weight="bold" color="dimmed" mt="2px">
                {value}%
            </Text>
        </Group>
    )
}

export default BatteryStatus
